import { render } from "./gdpr.vue?vue&type=template&id=a957fa10&scoped=true"
import script from "./gdpr.vue?vue&type=script&lang=js"
export * from "./gdpr.vue?vue&type=script&lang=js"

import "./gdpr.vue?vue&type=style&index=0&id=a957fa10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a957fa10"]])

export default __exports__